import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";
// component

// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPopover-paper": {
    width: "200px",
  },
}));

//
const VerticalToolsNav = ({ navRoot, topItems, bottomItems }) => {
  // style
  const classes = useStyles();
  // props
  // local state

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      {...navRoot}
    >
      <Grid
        item
        container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        rowSpacing={1}
      >
        {topItems.map((item, idx) => (
          <Grid item key={idx.toString()}>
            {item.item}
          </Grid>
        ))}
      </Grid>
      <Grid
        item
        container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        rowSpacing={1}
      >
        {bottomItems.map((item, idx) => (
          <Grid item key={idx.toString()}>
            {item.item}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

VerticalToolsNav.propTypes = {
  navRoot: PropTypes.objectOf(PropTypes.any),
  topItems: PropTypes.arrayOf(PropTypes.any),
  bottomItems: PropTypes.arrayOf(PropTypes.any),
};

VerticalToolsNav.defaultProps = {
  navRoot: {},
  topItems: [],
  bottomItems: [],
};

export default VerticalToolsNav;
